<div class="page-header-container">
  <div class="page-header-content">
    <md-page-header title="{{ 'LABELS.LOGISTICS' | translate }}" icon="partner"></md-page-header>
    <mat-form-field class="page-header-right-column no-subscript">
      <mat-label>{{ 'SEARCH.PARTNERS.LOGISTICS' | translate }}</mat-label>
      <input matInput type="text" [formControl]="searchInput" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
<ag-grid-angular
  domLayout="autoHeight"
  (rowClicked)="onRowClicked($event)"
  [pagination]="true"
  [theme]="theme"
  [rowData]="displayPartners()"
  [columnDefs]="columnDefs()"
></ag-grid-angular>
